// Terminals are shown as "T" + designator everywhere ("T3", "T2E", "TS").
//
// Transfer bookings already store them that way: the booking form saves 'T' + the flight
// lookup's terminal (B2CPages/constants.js). Standalone VIP bookings and live flight data
// carry the bare designator ("3", "2E", "S") — pass those through this to show them the
// same way. Display only: stored values are never rewritten (the AirLabs flight-alert
// matching relies on standalone VIP storing the bare value).
//
// Empty, whitespace and the "-" placeholder some callers pass are "no terminal" → null, so
// callers keep their own fallback (`displayTerminal(x) || '-'`).
export const displayTerminal = value => {
  if (value === null || value === undefined) return null
  if (typeof value !== 'string' && typeof value !== 'number') return null
  const text = String(value).trim()
  if (!text || text === '-') return null
  return `T${text}`
}
